import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPDimensionsModal from 'components/consumer/PDP/PDPDimensionsModal';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import Placeholder from 'components/consumer/Placeholder';
const PDPDimensionsAndDetailsUI = t0 => {
  const $ = _c(19);
  const {
    loading
  } = t0;
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  let t1;
  if ($[0] !== loading) {
    t1 = loading ? <Placeholder type="rect" loading={true} style={{
      height: "28px",
      width: "220px"
    }} /> : "Dimensions";
    $[0] = loading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h2 className="text-xl font-bold text-gray">{t1}</h2>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== loading) {
    t3 = !loading && <Link className="text-xs font-bold text-brand no-underline hover:cursor-pointer hover:underline" to="/fit-guide" target="_blank">Measure for delivery</Link>;
    $[4] = loading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="items-center flex justify-between">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsDimensionsModalOpen(true);
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== loading) {
    t6 = <PDPDimensionsContent onImageClick={t5} isSidebarContent={true} pageLoading={loading} />;
    $[10] = loading;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsDimensionsModalOpen(false);
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isDimensionsModalOpen) {
    t8 = <BrowserOnly><PDPDimensionsModal isOpen={isDimensionsModalOpen} onClose={t7} /></BrowserOnly>;
    $[13] = isDimensionsModalOpen;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t9 = <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]">{t4}{t6}{t8}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
PDPDimensionsAndDetailsUI.propTypes = {
  loading: PropTypes.bool
};
export default PDPDimensionsAndDetailsUI;